
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import icons from './icons';

const init = () => {
  library.add(...Object.values(icons));
//   dom.watch();
};

export default init;
